import React, { useContext, useState, useEffect } from "react";
import { API } from "src/shared/api/api";
import { Contracts } from "src/enitities/Table";
import { ContractsContext, addRow } from "src/shared";
import { saveRow, removeRow } from "src/shared";

export default function TableContracts() {
  const { token, websocket, data, pathname } = useContext(ContractsContext);
  const [dataSource, setDataSource] = useState(data);

  useEffect(() => {
    if (data) {
      setDataSource(data);
    }
  }, [data]);

  useEffect(() => {
    websocket.onmessage = (message) => {
      const data = JSON.parse(message.data);
      if (data.target === "contracts") {
        if (data.action === "create") {
          addRow(dataSource, data.result, setDataSource);
        }
        if (data.action === "edit") {
          saveRow(dataSource, data.result, setDataSource);
        }
        if (data.action === "delete") {
          removeRow(dataSource, data.result.id, setDataSource);
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, dataSource]);

  return (
    <Contracts
      dataSource={dataSource}
      handleSave={API.crud.edit(token, pathname)}
      handleRemove={API.crud.remove(token, pathname)}
    />
  );
}
